module.exports = __webpack_public_path__ + "static/media/logo.53eba517.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/logo.png
// module id = 389
// module chunks = 1